function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.023,
    viewBox: "0 0 17.5 17.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5924"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "shopping-cart (3)",
    transform: "translate(-.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 360",
    cx: 0.727,
    cy: 0.727,
    r: 0.727,
    transform: "translate(6.091 14.818)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 361",
    cx: 0.727,
    cy: 0.727,
    r: 0.727,
    transform: "translate(14.091 14.818)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40495",
    d: "M1 1h2.909l1.949 9.738a1.455 1.455 0 0 0 1.455 1.171h7.069a1.455 1.455 0 0 0 1.455-1.171L17 4.636H4.636",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.651f9157ce99b0a4abf739e4fd02a8ed.svg";
export { ForwardRef as ReactComponent };